import React from 'react'
import ReactModal from 'react-modal'

export default function Modal({ children }) {

  let bgStyle = {
    backdropFilter: 'blur(8px)',
    backgroundColor: 'rgba(255,255,255,0.34)',
    boxShadow: 'inset 0 -6px 63px 0 rgba(255,255,255,0.43)',
  }


  return (
    <ReactModal
      isOpen
      style={{
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          border: 'none',
          minWidth:'350px',
          maxWidth: '400px',
          borderRadius: '20px',
          marginRight: '-50%',
          boxShadow: '0 0 10px #AAAAAA',
          transform: 'translate(-50%, -50%)',
          zIndex:100
          // ...bgStyle
        },
      }}>
      <div>{children}</div>
    </ReactModal>
  )
}
